/**
 * Human-readable phone display for Lao / regional numbers stored in DB.
 * Does not validate; only groups digits for scanning.
 */
export function formatPhoneDisplay(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 0) return trimmed;

  const intl = trimmed.startsWith("+");

  // +856 20 XX XXX XXX (13 digits total: 856 + 10)
  if (intl && digits.startsWith("856") && digits.length === 13) {
    const n = digits.slice(3);
    return `+856 ${n.slice(0, 2)} ${n.slice(2, 4)} ${n.slice(4, 7)} ${n.slice(7, 10)}`;
  }

  // 020 1234 5678 / 030 3456 7890
  if (digits.length === 11 && digits.startsWith("0")) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 7)} ${digits.slice(7)}`;
  }

  // 20 1234 5678 (10 digits, unitel / telecom prefixes without leading 0)
  if (digits.length === 10 && /^(20|30)\d{8}$/.test(digits)) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
  }

  // Fallback: thin groups from the left for longer IDs
  if (digits.length <= 15) {
    return digits.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
  }

  return trimmed;
}
